// extracted by mini-css-extract-plugin
export default {"chip":"selected-filters_chip__1T8jH","text":"selected-filters_text__uy7mF"};